function copyToClipboard(text) {
    const aux = document.createElement('input');
    aux.setAttribute('value', text);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
}

jQuery(document).ready(function ($) {
    $('[href="#copy-link"]').click(function (e) {
        e.preventDefault();
        copyToClipboard($(this).parent().find('input').val());
    });
});
